export default "__VITE_ASSET__99008815__"